import { Box, SxProps, Theme } from "@mui/material";
import React, { PropsWithChildren } from "react";
import DocumentActions from "./DocumentActions";

type Props = PropsWithChildren<{
  onSignaturesClick?: () => void;
  onVersionsClick?: () => void;
}>;

const DocumentSidebar = ({
  onSignaturesClick,
  onVersionsClick,
  children,
}: Props) => {
  const container: SxProps<Theme> = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  };

  const innerContainer: SxProps<Theme> = {
    flex: 1,
  };

  return (
    <Box sx={container}>
      <Box sx={innerContainer}>{children}</Box>
      <DocumentActions
        onSignaturesClick={onSignaturesClick}
        onVersionsClick={onVersionsClick}
      />
    </Box>
  );
};

export default DocumentSidebar;
